import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import CoverFill from '../components/CoverFill';
import Reveal from '../components/Reveal';
import { shuffleArray } from '../utils/shuffle';
import { imagesFor } from '../utils/galleries';
import { personSchema, breadcrumbSchema } from '../utils/schema';
import content from '../content/about.json';

const About = () => {
  const band = useMemo(() => shuffleArray(imagesFor('places')), []);

  return (
    <main className="textPage">
      <SEO
        content={content}
        jsonLd={[
          personSchema(),
          breadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: 'About', path: '/about' },
          ]),
        ]}
      />
      <article>
        <header className="textPage__head">
          <Reveal as="h1" className="label textPage__label">
            About
          </Reveal>
          <Reveal as="p" className="textPage__lede" delay={0.05}>
            {content.lede}
          </Reveal>
        </header>
        <Reveal className="textPage__body" delay={0.1}>
          {content.body.map((para) => (
            <p key={para.slice(0, 24)}>{para}</p>
          ))}
        </Reveal>
      </article>

      <Reveal className="textPage__band">
        <CoverFill pool={band} altFor={(img) => img.caption || 'Landscape photograph by Jonny Coe'} />
      </Reveal>

      <nav className="textPage__next" aria-label="Continue">
        <Link to="/work" className="detailNav__next">
          <span className="label">See the work</span>
          <span className="detailNav__title">All galleries &amp; trips</span>
        </Link>
      </nav>
    </main>
  );
};

export default About;
